import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'gt0007',
    ecrans: [
        '01-2',
        '02-2'
    ]
});
